import { TaiLieu } from "./TaiLieu";

export class QuaTrinhCongTac {
    "id": number;
    "idNhanVien": number;
    "ngayBatDau": Date;
    "ngayKetThuc": Date;
    "tenDonVi": string;
    "phongBan": string;
    "chucVu": string;
    "dsTaiLieu": Array<TaiLieu>;
}